import React from 'react';
import Skeleton, { SkeletonAvatar } from '@pushpay/skeleton';
import { clsx, createUseStyles, multiply } from '@pushpay/styles';
import { useMediaBreakpoint } from '@pushpay/theming';
import useSharedStyles from './use-styles';
const useStyles = createUseStyles(theme => {
  const multiplyGutter = index => multiply(theme.SPACING.GUTTER, index);

  return {
    loadingOrgWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: multiplyGutter(4)
    },
    loadingOrgName: {
      width: '100px',
      margin: `${multiplyGutter(2.5)} 0`
    },
    loadingNavItemsContainer: {
      margin: `${multiplyGutter(2)} ${multiplyGutter(5)} 0 ${multiplyGutter(3)}}`
    },
    loadingNavItem: {
      width: 'auto',
      '&+&': {
        marginTop: multiplyGutter(5)
      }
    }
  };
});

const LoadingNavigation = props => {
  const {
    className,
    classes: classesProp,
    'data-pp-at-target': targetId,
    deprecated,
    ...rest
  } = props;
  const sharedClasses = useSharedStyles(undefined);
  const classes = useStyles(classesProp);
  const wrapper = clsx(className, sharedClasses.root);
  const isTabletAndBelow = useMediaBreakpoint('TABLET_AND_BELOW');
  const navItemsDefinitions = Array(8).fill({
    width: 100,
    avatar: true
  });

  if (isTabletAndBelow) {
    return /*#__PURE__*/React.createElement("div", {
      className: sharedClasses.mobileWrapper
    }, /*#__PURE__*/React.createElement(SkeletonAvatar, {
      size: 40
    }));
  }

  return /*#__PURE__*/React.createElement("nav", Object.assign({
    className: wrapper
  }, rest), deprecated && /*#__PURE__*/React.createElement("header", {
    className: classes.loadingOrgWrapper,
    "data-pp-at-target": "nav-org-logo"
  }, /*#__PURE__*/React.createElement(SkeletonAvatar, {
    "data-pp-at-target": `${targetId}-org-logo`,
    size: 60
  }), /*#__PURE__*/React.createElement(Skeleton, {
    className: classes.loadingOrgName,
    rows: 1,
    "data-pp-at-target": `${targetId}-org-name`
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.loadingNavItemsContainer
  }, /*#__PURE__*/React.createElement(Skeleton, {
    classes: {
      row: classes.loadingNavItem
    },
    rows: navItemsDefinitions,
    "data-pp-at-target": `${targetId}-items-id`
  })));
};

export default LoadingNavigation;